"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Card = _interopRequireDefault(require("react-bootstrap/Card"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * The Card component is a container for content.
 */
const Card = props => {
  const {
    children,
    variant,
    ...rest
  } = props;
  const className = variant === 'basic' ? '' : `card--${variant}`;
  return /*#__PURE__*/_react.default.createElement(_Card.default, _extends({
    className: className
  }, rest), children);
};
Card.propTypes = {
  /**
   * The contents of the Card.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Cards come in 'basic', 'dark', 'flat', 'outline'
   */
  variant: _propTypes.default.oneOf(['basic', 'dark', 'flat', 'outline'])
};
Card.defaultProps = {
  variant: 'basic'
};

/**
 * A label on a Card. Displayed as "eyebrow" text.
 */
const CardLabel = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "eyebrow"
  }, children);
};
CardLabel.displayName = 'Card.Label';
CardLabel.propTypes = {
  /**
   * The text content of the Label.
   */
  children: _propTypes.default.node.isRequired
};

/**
 * The text inside a Card. Displayed in a "div".
 */
const CardText = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "card-text"
  }, children);
};
CardText.displayName = 'Card.Text';
CardText.propTypes = {
  /**
   * The content of the card Text.
   */
  children: _propTypes.default.node.isRequired
};

/**
 * The title of a Card. Displayed in a "div".
 */
const CardTitle = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "h3 card-title"
  }, children);
};
CardTitle.displayName = 'Card.Title';
CardTitle.propTypes = {
  /**
   * The content of the card Title.
   */
  children: _propTypes.default.node.isRequired
};
_Card.default.Body.displayName = 'Card.Body';
Card.Body = _Card.default.Body;
_Card.default.Footer.displayName = 'Card.Footer';
Card.Footer = _Card.default.Footer;
Card.Label = CardLabel;
Card.Text = CardText;
Card.Title = CardTitle;
var _default = exports.default = Card;